<div class="cm-skeleton-navbar">
  <div class="cm-skeleton-navbar__top">
    <div class="cm-skeleton-navbar__top__left">
      <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}"></div>
    </div>
    <div class="cm-skeleton-navbar__top__right">
      <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}"></div>
    </div>
  </div>
  <div class="cm-skeleton-navbar__menu">
    @for (item of [1, 2, 3, 4, 5, 6, 7]; track item) {
      <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}"></div>
    }
  </div>
</div>
